/* eslint-disable @typescript-eslint/explicit-function-return-type */
import styled, { css } from 'styled-components/macro';
import modularScale from 'styles/helpers/modular-scale';
import { ThemeProps } from 'types/styled';
import { stripUnit } from 'polished';
import { primaryTypography } from 'styles/global/typography/typography';
import colors from 'styles/themes/colors';
import Button from 'components/elements/button';

import {
  compose,
  space,
  color,
  border,
  typography,
  flexbox,
  position,
  layout,

  // types
  SpaceProps,
  TypographyProps,
  ColorProps,
  FlexboxProps,
  LayoutProps,
} from 'styled-system';

export const OpenPopupButton = styled.button`
  appearance: none;
  background: transparent;
  font-size: ${modularScale(-2)};
  color: white;
  letter-spacing: 0.1em;
  text-align: center;
  border-radius: 0.2em;
  font-weight: 600;
  line-height: 1.6;
  text-transform: uppercase;
  box-sizing: content-box;
  position: relative;
  white-space: nowrap;
  margin: 0;
  border: 1px solid white;
  margin-left: ${({ theme }): string => theme.spacing.xsmall};
  padding: ${({ theme }): string =>
    `0 ${theme.spacing.medium} 0 ${theme.spacing.medium}`};
  display: flex;
  align-items: center;

  &.placeholder {
    visibility: hidden;
  }

  &:disabled {
    opacity: 0.5;
  }

  & svg {
    vertical-align: middle;
    margin: 2px 5px 3px 0;
    color: white;
  }
`;

export const NoDataCustomListTitle = styled('h4')<ThemeProps<'h4'>>`
  display: inline-block;
  font-weight: 600;
  color: ${({ theme }) => theme.Grey};
  line-height: 1.2;
  margin: 0;
  font-size: 0.8em;

  &:not(:last-child) {
    margin-right: ${stripUnit(modularScale(-3))}rem;
  }
`;

export const CustomListTitle = styled('h3')<ThemeProps<'h3'>>`
  display: inline-block;
  font-weight: 600;
  color: ${({ theme }) => theme.DeepBlue};
  line-height: 1.2;
  margin: 0;
  font-size: 1em;

  &:not(:last-child) {
    margin-right: ${stripUnit(modularScale(-3))}rem;
  }
`;

export const CustomListLastupdated = styled('div')`
  ${primaryTypography};
  color: ${colors.CasperGrey};
  font-size: ${modularScale(-1)};
`;

export const ListItemBox = styled.li`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid ${colors.LightGrey};
  padding-bottom: 0.5em;
  margin-bottom: 0.5em;

  &:hover ${Button} {
    background-color: ${colors.LightGrey};
  }
`;

export const CreateNewListButton = styled(Button)`
  @media screen and (min-width: 30em) {
    padding-left: 0.7em;
  }

  & svg {
    transform: translate(0, 6px) scale(0.7);
  }
`;

const BaseCheckButton = css`
  height: 3.4em;
  width: 3.4em;

  & svg {
    margin: 0;
  }
`;

export const CheckButton = styled(Button)`
  ${BaseCheckButton}
`;

type DisabledCheckButtonProps = SpaceProps &
  TypographyProps &
  ColorProps &
  FlexboxProps &
  LayoutProps;

export const DisabledCheckButton = styled.button<DisabledCheckButtonProps>`
  pointer-events: none;
  ${compose(space, typography, color, border, flexbox, position, layout)}
  ${BaseCheckButton};
`;
